export default __webpack_public_path__ + "static/media/Animations_Circle7.cf379eac.svg";